<template>
  <div class="auth">
      <div class="container">
          <div class="auth__inner">
              <div class="auth__head">
                  <div class="auth__preview">
                      <img src="/static/img/logo-color.svg" alt="" class="auth__preview__img">
                  </div>
              </div>
              <form class="auth__body"  @submit.prevent="sendPassword()">
                  <div class="auth__body__main">
                      <h2 class="auth__title">Forgot Password?</h2>
                      <p class="auth__desc">Enter the email address and we’ll send you instructions to reset your password.</p>
                      <div class="auth__form">
                          <div class="auth__form__block auth__form__block--fullw">
                              <input type="email" class="input-default" placeholder="Enter Email Address" v-model="email">
                          </div>
                      </div>
                  </div>

                  <div class="auth__body__controls">
                      <button type="submit" class="button button--primary">reset password</button>
                      <router-link class="button button--secondary-otln" to="/">Back to site</router-link>
                  </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Forgot',
  data () {
    return {
      email: ''
    }
  },
  head: {
    title: {
      inner: 'Forgot Password',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'Forgot Password page Ad Operator'
      },
      {
        name: 'keywords',
        content: 'Forgot, Password'
      },
      {
        property: 'og:title',
        content: 'Forgot Password - Ad Operator'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/forgot'
      },
      {
        property: 'og:description',
        content: 'Forgot Password page Ad Operator'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co/forgot',
        id: 'canonical'
      }
    ]
  },
  components: {
    Swal
  },
  methods: {
    sendPassword: function () {
      axios.get('/api/reset?email=' + encodeURIComponent(this.email))
        .then(function (response) {
          if (response.data.status === 200) {
            Swal('Success', 'A new password has been sent to your e-mail address', 'success')
          } else {
            Swal('Warning', 'Something wrong!', 'warning')
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/account/forgot.vue